import component from './HeatingInterest.vue';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import {
  FormMultipleChoiceComponentConfig,
  FormMultipleChoiceValueType,
  StepDefinition,
} from '@/interfaces/step-definition';
import { AssistantStepContext } from '@/interfaces/context';
import { FormFieldType } from '@/consts/input-types';
import { FormFieldGroupId } from '~/consts/assistant-form-field-groups';

export interface HeatingInterestStepContext extends AssistantStepContext {
  heatingInterest: FormMultipleChoiceValueType;
}

const config: StepDefinition = {
  component,
  hideSkipMessage: () => true,
  fields: [
    {
      component: {
        columns: 4,
        // disableUnselect: true,
        hideCheckbox: true,
        options: [
          {
            value: 'heat-pump',
            image: {
              file: 'img/icon/heater-heat-pump.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'hybrid',
            image: {
              file: 'img/icon/heater-hybrid.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'gas',
            image: {
              file: 'img/icon/heater-gas.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'storage',
            image: {
              file: 'img/icon/heater-storage.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
        ],
        singleAnswer: true,
        verticalOptionLayout: true,
      } as FormMultipleChoiceComponentConfig,
      name: 'heatingInterest',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.HEATER,
    },
  ],
  id: StepId.HEATING_INTEREST,
  categoryId: StepCategoryId.HEATING,
};

export default config;
